import type { ImgHTMLAttributes } from "react";
import {
  optimizedImagePath,
  optimizedImageSrcSet,
} from "~/utils/optimizedImage";

type OptimizedImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  src: string;
  widths?: number[];
  fallbackWidth?: number;
};

export function OptimizedImage({
  src,
  alt = "",
  decoding = "async",
  widths = [480, 780, 1170],
  fallbackWidth = widths[Math.floor(widths.length / 2)] ?? 780,
  ...props
}: OptimizedImageProps) {
  const canUseOptimizedSrc =
    src.startsWith("/") && /\.(jpe?g|png)$/i.test(src);

  return (
    <img
      {...props}
      alt={alt}
      decoding={decoding}
      src={canUseOptimizedSrc ? optimizedImagePath(src, fallbackWidth) : src}
      srcSet={
        canUseOptimizedSrc ? optimizedImageSrcSet(src, widths) : props.srcSet
      }
      sizes={canUseOptimizedSrc ? (props.sizes ?? "100vw") : props.sizes}
    />
  );
}
